<template>
  <v-card class="mb-12" elevation="0">
    <v-form>
      <v-row>
        <v-col md="6" cols="12">
          <label>عنوان دوره</label>
          <v-text-field v-model="dataModel.title" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
            hide-details></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>وضعیت دوره</label>
          <v-select clearable :items="statusItems" class="rounded-lg mt-2 sm-font400-14" item-text="title"
            item-value="id" hide-details solo v-model="dataModel.is_active"></v-select>
        </v-col>
        <v-col cols="122">
          <label>تعداد جلسات</label>
          <v-text-field v-model="dataModel.session_count" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>
        <v-col cols="12">
          <label>توضیحات</label>
          <v-textarea v-model="dataModel.description" class="rounded-lg mt-2 sm-font400-14" rows="7" hide-details
            solo></v-textarea>
        </v-col>
        <v-col cols="12">
          <label>ویدیو دوره</label>
          <v-file-input v-model="dataModel.video" prepend-icon="" append-icon="mdi-upload"
            class="rounded-lg mt-2 sm-font400-14" solo hide-details @change="changedVideo">
            <template slot="prepend-inner"
              v-if="dataModel.video && dataModel.video !== '' && dataModel.video !== null && showVideoPerview">
              <a target="_blank" :href="dataModel.video">video.mp4</a>
            </template>
          </v-file-input>
        </v-col>
        <v-col cols="12">
          <label>فایل معرفی دوره</label>
          <v-file-input v-model="dataModel.description_file" prepend-icon="" append-icon="mdi-upload"
            class="rounded-lg mt-2 sm-font400-14" solo hide-details @change="changedFile">
            <template slot="prepend-inner"
              v-if="dataModel.description_file && dataModel.description_file !== '' && dataModel.description_file !== null && showFilePerview">
              <a target="_blank" :href="dataModel.description_file">file.pdf</a>
            </template>
          </v-file-input>
        </v-col>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn color="positive" class="textColor--text sm-font500-16 rounded-xl me-3" depressed height="48"
            width="230" :loading="loading" @click="nextStep">
            ثبت و ادامه
          </v-btn>

          <v-btn width="230" height="48" depressed color="nagative" class="textColor--text sm-font500-16 rounded-xl"
            @click="cancelProcess">
            انصراف
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import courseApi from "@/Services/modules/courses";

export default {
  name: "steps",
  props: {
    contentData: {
      type: Object,
      default: () => ({
        course_type: "Offline"
      })
    },
    formType: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      
      dataModel: this.contentData,
      statusItems: [{ id: true, title: "فعال" }, { id: false, title: "غیرفعال" }],
      showImagePerview: true,
      showVideoPerview: true,
      showFilePerview: true
    }
  },
  methods: {
    nextStep() {
      
      let formData = new FormData();
      formData.append("course_type", "Offline");
      formData.append("title", this.dataModel.title);
      formData.append("is_active", this.dataModel.is_active);
      formData.append("description", this.dataModel.description);
      // formData.append("lesson_count", this.dataModel.lesson_count);
      formData.append("session_count", this.dataModel.session_count);
      if (this.dataModel.image) {
        formData.append("image", this.dataModel.image)
      }
      if (this.dataModel.video) {
        formData.append("video", this.dataModel.video)
      }
      if (this.dataModel.description_file) {
        formData.append("description_file", this.dataModel.description_file)
      }
      let configHeader = {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
      this.loading= true
      if (this.formType === 'create') {
        courseApi.addStepToCourse(formData, configHeader).then(res => {
          this.$router.push(`/courses/bootcamp/edit/${res.data.id}?step=2`)
        }).catch((err) => {
          console.log(err);
        }).finally(()=>{
          this.loading= false
        })
      } else {
        courseApi.editStepCourse({ data: this.dataModel, id: this.$route.params.id }, configHeader).then(() => {
          this.$emit('nextStep', 2)
        }).catch((err) => {
          console.log(err);
        }).finally(()=>{
          this.loading= false
        })
      }
      // this.$emit('nextStep', 2)
    },
    cancelProcess() {
      this.$router.push('/courses/course-list')
    },
    changedImage() {
      this.showImagePerview = false
    },
    changedVideo() {
      this.showVideoPerview = false
    },
    changedFile() {
      this.showFilePerview = false
    }
  }
}
</script>

<style scoped></style>
